.modal {
  max-width: 640px;
  z-index: var(--z-header-dropdown);
}

.container {
  padding: var(--space-32);
}

.header {
  justify-content: flex-end;
}

.closeButton {
  font-size: 20px;
  color: var(--grey-700);
  cursor: pointer;

  &:hover {
    color: var(--grey-900);
  }
}

.headingSection {
  text-align: center;
}

.heading {
  color: var(--grey-900);
}

.subheading {
  color: var(--grey-700);
}

.featuresSection {
  align-items: center;
  background-color: var(--grey-50);
  border: 1px solid var(--grey-300);
  border-radius: 8px;
  padding: var(--space-24);
}

.featuresHeading {
  color: var(--grey-900);
  font-weight: 600;
  letter-spacing: 0.5px;
}

.feature {
  flex: 1;
  align-items: flex-start;
}

.checkIcon {
  color: var(--green-600);
  font-size: 20px;
  flex-shrink: 0;
  margin-top: 2px;
}

.featureDescription {
  color: var(--grey-700);
}

.actions {
  button {
    flex: 1;
  }
}

.disclaimer {
  text-align: center;
  color: var(--grey-700);
}
